import { useEffect, useRef, useState } from 'react'

function ToolboxIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" />
      <path d="M8 9V7a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M3 14h18" />
      <path d="M10 14v3h4v-3" />
    </svg>
  )
}

// Circular toolbox button beside the account avatar. Opens an empty menu for now.
function ProjectsMenu() {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [open])

  return (
    <div className="projects-menu" ref={ref}>
      <button
        type="button"
        className="projects-bubble"
        title="Projects"
        aria-label="Projects"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <ToolboxIcon />
      </button>

      {open && <div className="projects-dropdown" role="menu" aria-label="Projects" />}
    </div>
  )
}

export default ProjectsMenu
